import { render, staticRenderFns } from "./DirectionsSearchResultItem.vue?vue&type=template&id=4f37a103&scoped=true&"
import script from "./DirectionsSearchResultItem.vue?vue&type=script&lang=js&"
export * from "./DirectionsSearchResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f37a103",
  null
  
)

export default component.exports